<template>
  <div class="app-container" uk-height-viewport="expand: true">
    <div class="uk-width-1-1 top-padding" id="authorship-content">
      <div class="uk-padding uk-card uk-card-default uk-card-body">
        <h1>{{$t('authorship.heading')}}</h1>
        <p class="paragraph-one">
          {{$t('authorship.description')}}
          <br>
          <br>
          {{$t('authorship.selectionHeading')}}
        </p>
        <ul uk-accordion>
          <li>
            <div class="uk-accordion-title" href="#">
              {{$t('authorship.stillHaveAccessDropdown.title')}}
            </div>
            <div class="uk-accordion-content">
              <h3>{{$t('authorship.stillHaveAccessDropdown.heading')}}</h3>
              <span class="link" v-html="$t('authorship.stillHaveAccessDropdown.description1')"></span>
              <br><br>
              <span class="link" v-html="$t('authorship.stillHaveAccessDropdown.description2')"></span>
              <br><br>
              <span>{{$t('authorship.stillHaveAccessDropdown.description3')}}</span>
              <br><br>
              <span v-html="$t('authorship.stillHaveAccessDropdown.description4')"></span>
              <span class="link" @click="openRoute(manageResourcesRoute)" v-html="$t('authorship.stillHaveAccessDropdown.description5')"></span>
              <span>{{$t('authorship.stillHaveAccessDropdown.description6')}}</span>

            </div>
          </li>
          <li>
            <div class="uk-accordion-title" href="#">{{$t('authorship.cannotAccessDropdown.title')}}</div>
            <div class="uk-accordion-content">
              {{$t('authorship.cannotAccessDropdown.description1')}}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import Router from '../../router/index'
  import * as routes from '../../enums/routes'
  import {mapGetters} from 'vuex'

  export default {
    name: 'authorship',
    props: ['download', 'id'],
    data() {
      return {
        manageResourcesRoute: routes.MANAGE_RESOURCES,
        shareResourcesRoute: routes.SHARE_RESOURCE
      }
    },
    metaInfo() {
      return {
        meta: [
          { name: 'robots',
            content: 'noindex'
          }
        ]
      }
    },
    methods: {
      openRoute(route) {
        if (this.authenticated) {
          Router.push(route)
        } else {
          let state = {
            from: route,
            download: false
          }
          this.$auth.id.signIn(state)
        }
      }
    },
    computed: {
      ...mapGetters('auth/id', ['authenticated'])
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../styles/breakpoints';
  @import '../../styles/colours';

  .link {
    /deep/
    a {
      color: $content-link-blue;
      font-weight: bold;
    }
  }

  ul.uk-accordion {
    background-color: #f7f7f7;
    border-radius: 2px;
  }

  li {
    .uk-accordion-title {
      cursor: pointer;
      padding: 15px;
      line-height: 1.25;
      color: rgba(0, 1, 2, 0.7);
      font-size: 16px;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
      margin: 0 0 1px 0;
    }

    &:hover {
      border-radius: 2px;
      background-color: #ffffff;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
    }
  }

  .uk-accordion-content {
    background-color: white;
    padding: 24px 32px 32px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    line-height: 25px;
  }

  .uk-accordion-content,
  .uk-accordion > :nth-child(n+2) {
    margin-top: 0;
  }

  .uk-padding {
    padding: 56px 80px 83px 80px;
  }

  h1, h2, h3, h4 {
    font-weight: bold;
    color: rgba(0, 1, 2, 0.7);
  }

  h1 {
    font-size: 28px;
    line-height: 1.18;
  }

  h2 {
    font-size: 22px;
    line-height: 1.14;
  }

  h3 {
    font-size: 20px
  }

  h4 {
    font-size: 18px;
  }

  .paragraph-one {
    font-size: 16px;
    line-height: 1.56;
    color: rgba(0, 1, 2, 0.7);
  }

  #authorship-content .uk-accordion {
    .uk-accordion-title:before {
      background-image: url('../../../node_modules/uikit/src/images/icons/chevron-down.svg') !important;
    }

    .uk-open {
      .uk-accordion-title:before {
        background-image: url('../../../node_modules/uikit/src/images/icons/chevron-up.svg') !important;
      }
    }
  }

  .column-padding {
    padding-left: 24px;
  }

  .top-padding {
    padding-top: 86px;
  }

  @media screen and (max-width: $breakpoint-medium) {
    .app-container {
      width: 100%;
    }
    .top-padding {
      padding-top: 120px;
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .uk-padding {
      padding: 15px 25px 15px 25px;
    }
    .top-padding {
      padding-top: 120px;
    }
    .link-wrap {
      word-break: break-word;
    }
  }
</style>
